/* ===== Anadita Luxe — countdown ===== */
(function () {
  'use strict';
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date((el.dataset.countdown || '').replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    var d = el.querySelector('[data-cd-days]'), h = el.querySelector('[data-cd-hours]'), m = el.querySelector('[data-cd-mins]'), s = el.querySelector('[data-cd-secs]');
    var timer = el.querySelector('[data-countdown-timer]');
    var label = el.querySelector('[data-countdown-label]');
    var activeMessage = el.dataset.activeMessage || 'Here now';
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (timer) timer.innerHTML = '<span>' + activeMessage + '</span>';
        if (label) label.style.display = 'none';
        clearInterval(iv);
        return;
      }
      var dd = Math.floor(diff / 86400000), hh = Math.floor(diff % 86400000 / 3600000), mm = Math.floor(diff % 3600000 / 60000), ss = Math.floor(diff % 60000 / 1000);
      if (d) d.textContent = pad(dd); if (h) h.textContent = pad(hh); if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
    }
    tick(); var iv = setInterval(tick, 1000);
  });
})();
